<script setup lang="ts">
import { useScopedLocalStorage } from '#layers/base/public';

defineOptions({ inheritAttrs: false });

defineProps<{
	localeKey: string;
	documentationLink: string;
	showAllFieldsToggle: boolean;
	snippets: { sdk: string; rest: string } | null;
}>();

const includeAllFields = defineModel<boolean>('includeAllFields', { default: false });

const tabs = [
	{ label: 'SDK', slot: 'sdk', value: 'sdk' },
	{ label: 'cURL', slot: 'curl', value: 'curl' },
];

const selectedTab = useScopedLocalStorage<string>('code-panel-language', 'sdk');
</script>

<template>
	<div class="flex flex-col gap-6 pt-2">
		<div class="flex flex-col gap-2">
			<p class="text-sm text-default">
				{{ $t(`${localeKey}.subtitle`) }}
			</p>

			<DTextLink
				class="w-fit text-sm"
				:text="$t('code_panel.learn_more')"
				:href="documentationLink"
				target="_blank"
			/>
		</div>

		<DSwitch
			v-if="showAllFieldsToggle"
			v-model="includeAllFields"
			size="sm"
			:label="$t('code_panel.all_fields')"
		/>

		<DTabs v-model="selectedTab" :items="tabs" variant="pill">
			<template #sdk>
				<InputCodeBlock
					:model-value="snippets?.sdk ?? ''"
					code-language="javascript"
					inert
					copy
					block
					:ui="{ base: 'max-h-none resize-none' }"
				/>
			</template>

			<template #curl>
				<InputCodeBlock
					:model-value="snippets?.rest ?? ''"
					inert
					copy
					:line-numbers="false"
					block
					:ui="{ base: 'max-h-none resize-none' }"
				/>
			</template>
		</DTabs>
	</div>
</template>
